// extracted by mini-css-extract-plugin
export default {"formWrapper":"user-details_formWrapper__8kJwD","fieldsWrapper":"user-details_fieldsWrapper__H5TVY","inputField":"user-details_inputField__hgdHT"};